import React from "react";

import TabletHorizontalSvg from "../../assets/images/icons/tablet-horizontal.svg";

export const TabletHorizontalIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={TabletHorizontalSvg}
        alt={alt || "Tablet Horizontal"}
    />
);
